export default {
  MCHASHID: "MCHASHID"
};
